import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { useDispatch } from 'react-redux';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import api from '../api';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import CreateAndUpdateModal from '../sections/@dashboard/game/CreateAndUpdateModal';
import moment from 'moment';
import { updateGameAction } from 'src/redux/actions/masterGameAction';
import UpdateResultModal from 'src/sections/@dashboard/resultDeclare/UpdateResultModal';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import FilterByPendigStatus from 'src/sections/@dashboard/pendingResults/FilterByPendigStatus';
import { row_per_page_data } from 'src/utils/commonUtils';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'game_name', label: 'Game Name', alignRight: false },
  { id: 'game_update_at', label: 'Game Date', alignRight: false },
  { id: 'is_open_pending', label: 'Open Result Declare', alignRight: false },
  { id: 'is_close_pending', label: 'Close Result Declare', alignRight: false },
  { id: 'is_refunded', label: 'Refunded', alignRight: false },
  { id: 'action', label: 'Action', alignRight: true },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function PendingResultPage() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[0]);

  const [pendingResultData, setPendingResData] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = pendingResultData.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  // const getAllPendigResults = async () => {
  //   dispatch(loadingStartAction());
  //   const response = await api.get('/pending-results');
  //   setPendingResData(response.data);
  //   dispatch(loadingStopAction());
  // };

  const deleteGame = async () => {
    handleCloseMenu();
    const response = await api.delete(`/pending-results/${selectedGame._id}`);
  };

  // const resultDeclareHandler = async () => {
  //   handleCloseMenu();
  //   let req_body = {
  //     game_id: '64bfd9f3d791ef5cb070637f',
  //     session: 'open',
  //     open_panna: '234',
  //     open_digit: '9',
  //     master_game_created_date: '2023-07-25T14:19:40.447Z',
  //   };
  //   dispatch(updateGameAction(selectedGame));
  // };

  const getResultsByStatus = async (status) => {
    dispatch(loadingStartAction());
    let endpoint = '/pending-results/filter?';
    if (status === 1) {
      endpoint = endpoint + 'isOpenPending=true';
    } else if (status === 2) {
      endpoint = endpoint + 'isOpenPending=false';
    } else if (status === 3) {
      endpoint = endpoint + 'isClosePending=true';
    } else if (status === 4) {
      endpoint = endpoint + 'isClosePending=false';
    } else if (status === 5) {
      endpoint = endpoint + 'isRefund=true';
    } else if (status === 6) {
      endpoint = endpoint + 'isOpenPending=true&isClosePending=true';
    }
    const response = await api.get(endpoint);
    setPendingResData(response.data);
    dispatch(loadingStopAction());
  };

  const getTodaysResults = async (status) => {
    dispatch(loadingStartAction());
    let endpoint = '/pending-results/date-filter';
    const response = await api.get(endpoint);
    setPendingResData(response.data);
    dispatch(loadingStopAction());
  };

  useEffect(() => {
    getTodaysResults();
  }, []);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - pendingResultData?.length) : 0;

  const filteredFinalData = applySortFilter(pendingResultData, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredFinalData.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Pending Results
          </Typography>

          <FilterByPendigStatus getResultsByStatus={getResultsByStatus} />
        </Stack>

        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={pendingResultData?.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const {
                      _id,
                      master_game,
                      game_update_at,
                      is_pending,
                      is_close_pending,
                      is_open_pending,
                      is_refunded,
                    } = row;
                    // const selectedUser = selected.indexOf(master_game?.game_name) !== -1;

                    return (
                      <TableRow hover key={_id} >
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, master_game?.game_name)} /> */}
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            {/* <Avatar alt={master_game?.game_name} src={pic} /> */}
                            <Typography variant="subtitle2" noWrap>
                              {master_game?.game_name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        {/* MMMM Do YYYY, */}
                        <TableCell align="left">{moment.utc(game_update_at).format('MMMM Do')}</TableCell>

                        <TableCell align="left">
                          {is_refunded ? (
                            <Label>REFUNDED</Label>
                          ) : (
                            <Label color={is_open_pending ? 'error' : 'success'}>
                              {is_open_pending ? 'PENDING' : 'DECLARED'}
                            </Label>
                          )}
                        </TableCell>

                        <TableCell align="left">
                          {is_refunded ? (
                            <Label>REFUNDED</Label>
                          ) : (
                            <Label color={is_close_pending ? 'error' : 'success'}>
                              {is_close_pending ? 'PENDING' : 'DECLARED'}
                            </Label>
                          )}
                        </TableCell>

                        <TableCell align="left">
                          <Label color={is_refunded ? 'success' : "info"}>{is_refunded ? 'REFUNDED' : '---'}</Label>
                        </TableCell>

                        <TableCell align="right">
                          <UpdateResultModal selectedGame={row} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </>
  );
}
